import React from "react";
import { format } from "date-fns";
// components
import Text from "components/Text";
import { Visibility } from "components/Visibility";
import { OrderMirrorButton } from "../components/OrderMirrorButton";
import { AutomaticAnswerBudget } from "../components/AutomaticAnswerBudget";
// assets
import orangeCircleIcon from "img/orange-circle-icon.svg";
import pendingMoneyError from "img/pending-money-error-icon.svg";
// models
import { IQuotes } from "models/Quote";
import { IMessagesMoney } from "../components/Dropdown/BudgetDropdown/interface";
import { IQuoteOnMoney, ITableModel, SupplierStatusType } from "components/Table/interface";
import { IPreOrders, ViewedOrderProps } from "../components/Dropdown/PortalOrderDropdown/interface";
//utils
import { currencyOutputNumber } from "utils/CurrencyOutput";

export const messageTooltip = (data: IQuotes) => (
  data.supplierStatusDescription === "Respondida Portal" && data.hasPendingBudget ?
    "Possui CDs com orçamento pendente" : data?.supplierStatusMessage
);

export const handlePendingMoneyErrorIcon = (hasPendingMoneyErrorIcon: boolean) => {
  if (hasPendingMoneyErrorIcon) {
    return <img className="mr-1" src={pendingMoneyError} />;
  } else {
    return "";
  }
};

const viveoStatus = (data: IQuotes, hasPendingMoneyErrorIcon: boolean) => {
  if (data.supplierStatusDescription === SupplierStatusType.PENDING_MONEY ||
    (data.supplierStatusDescription === SupplierStatusType.ANSWERED_PORTAL && data.hasPendingBudget)) {
    return (
      <div style={{ display: "flex" }}>
        {handlePendingMoneyErrorIcon(hasPendingMoneyErrorIcon)}
        <Text
          size={12}
          width={140}
          className={'supplierStatus'}
          color={"#192c3d"}
          showTip
          showTipContent={messageTooltip(data)}
        >
          {data.supplierStatusDescription}
        </Text>
      </div>
    );
  } else if (data.supplierStatusDescription === SupplierStatusType.DO_NOT_PARTICIPATE) {
    return (
      <Text
        size={12}
        width={140}
        className={'supplierStatus'}
        color={"#192c3d"}
        showTip
        showTipContent={data.notParticipateStatusDescription}
      >
        {data.supplierStatusDescription}
      </Text>
    );
  } else {
    return (
      <div style={{ display: "flex" }}>
        <p className="supplierStatus">
          {data.supplierStatusDescription}
        </p>
      </div>
    );
  }
};

export const modelMoneyRecorded: Array<ITableModel> = [
  {
    label: "N° da Cotação",
    key: "code",
    noFilter: true,
    size: 110,
    maxSize: 110,
  },
  {
    label: "Data de criação",
    key: "createdAt",
    type: "date",
    noFilter: true,
    size: 120,
    maxSize: 120,
  },
  {
    label: "Origem",
    key: "origin",
    noFilter: true,
    size: 100,
    maxSize: 100,
  },
  {
    label: "C. Cliente",
    key: "company.crmCustomerCode",
    size: 100,
    maxSize: 100,
    noFilter: true,
  },
  {
    label: "Razão Social",
    key: "buyerName",
    size: 345,
    maxSize: 345,
    noFilter: true,
  },
  {
    label: "Qtd Itens",
    key: "itemsCount",
    noFilter: true,
    size: 80,
    maxSize: 80,
  },
  {
    label: "Status Bionexo",
    key: "statusDescription",
    size: 110,
    maxSize: 110,
    noFilter: true,
  },
  {
    label: "Status Viveo",
    size: 135,
    maxSize: 135,
    Component: (data) => (viveoStatus(data, true)),
  },
  {
    label: "Expira em",
    key: "expiresAt",
    type: "date/hour",
    noFilter: true,
    size: 145,
    maxSize: 145,
    Component: (data: IQuoteOnMoney) => (
      <Text>
        {format(new Date(data.expiresAt), "dd/MM/yyyy HH:mm")}
      </Text>
    ),
  }
];

export const modelExpiredNotAnswered: Array<ITableModel> = [
  {
    label: 'N° da Cotação',
    key: 'code',
    noFilter: true
  },
  {
    label: 'Data de criação',
    key: 'createdAt',
    type: 'date',
    noFilter: true
  },
  {
    label: 'Origem',
    key: 'origin',
    noFilter: true
  },
  {
    label: 'C. Cliente',
    key: 'company.crmCustomerCode',
    size: 100,
    noFilter: true
  },
  {
    label: 'Razão Social',
    key: 'buyerName',
    size: 345,
    noFilter: true
  },
  {
    label: 'Qtd Itens',
    key: 'itemsCount',
    noFilter: true
  },
  {
    label: 'Status Bionexo',
    key: 'statusDescription',
    size: 130,
    noFilter: true
  },
  {
    label: 'Status Viveo',
    key: 'supplierStatusDescription',
    Component: (data) => (viveoStatus(data, true)),
  },
  {
    label: 'Expira em',
    key: 'expiresAt',
    type: 'date/hour',
    size: 180,
    noFilter: true,
    Component: (data: any) => (
      <Text>
        {format(new Date(data.expiresAt), 'dd/MM/yyyy HH:mm')}
      </Text>
    ),
  },
];

export const modelBudgetSummary: Array<ITableModel> = [
  { 
    label: "", 
    key: "", 
    noFilter: true, 
    size: 30, 
    maxSize: 30,
    Component: () => <div></div>
  },
  { label: "CD", key: "distributionCenter", noFilter: true, maxSize: 88 },
  { label: "Itens", key: "qtdItens", noFilter: true, maxSize: 100 },
  {
    label: "Orçamento Money",
    key: "budgetMoney",
    maxSize: 175,
    noFilter: true,
  },
  {
    label: "Status Bionexo",
    key: "statusDescription",
    maxSize: 207,
  },
  {
    label: "Mensagem",
    key: "message",
    noFilter: true,
    maxSize: 288,
    Component: (data: IMessagesMoney) => {
      if (data.message) {
        return (
          <div style={{ display: "flex" }}>
            <Visibility visible={data.supplierStatusDescription === SupplierStatusType.PENDING_MONEY}>
              <img alt="pending Money error icon" src={pendingMoneyError} />
            </Visibility>
            <Text
              size={12}
              className={'ml-1 budgetMessage'}
              color={"#192c3d"}
              showTip={data.supplierStatusDescription === SupplierStatusType.PENDING_MONEY}
            >
              {data.message}
            </Text>
          </div>
        );
      }
    }
  },
  {
    label: "Valor (R$)",
    key: "totalValueCD",
    noFilter: true,
    maxSize: 173,
    Component: (data: IMessagesMoney) => {
      return (
        <Text
          size={12}
          color={"#192c3d"}
        >
          {currencyOutputNumber(data.totalValueCD)}
        </Text>
      );
    }
  },
  {
    label: "Atualização",
    key: "date",
    type: "date/hour",
    noFilter: true,
    size: 180
  },
  {
    label: "",
    key: "",
    size: 70,
    maxSize: 70,
    Component: (data: IMessagesMoney) => (
      <AutomaticAnswerBudget budget={data} />
    )
  }
];

export const orderModel: Array<ITableModel> = [
  {
    label: "CD",
    key: "distributionCenter",
    maxSize: 40,
    noFilter: true,
    Component: (data: IPreOrders) => {
      return (
        <Text
          size={12}
          color={"#192c3d"}
        >
          <Visibility visible={data?.isRecent}>
            <img src={orangeCircleIcon} className="orangeIcon" />
          </Visibility>
          {data.distributionCenter}
        </Text>
      );
    }
  },
  {
    label: "Resgate",
    key: "createdAt",
    type: "date/hour",
    noFilter: true,
    size: 180,
    Component: (data: IPreOrders) => (
      <Text size={12}>
        {format(new Date(data.createdAt), "dd/MM/yyyy' às 'HH:mm")}
      </Text>
    ),
  },
  {
    label: "Última atualização",
    key: "updatedDate",
    type: "date/hour",
    noFilter: true,
    size: 180,
    Component: (data: IPreOrders) => (
      <Text size={12}>
        {format(new Date(data.updatedDate), "dd/MM/yyyy' às 'HH:mm")}
      </Text>
    ),
  },
  {
    label: "Status",
    key: "statusPreOrderDetailsDescription",
    size: 140,
    noFilter: true
  },
  {
    label: "Categoria",
    key: "categoryDescription",
    size: 105,
    noFilter: true,
    Component: (data: IPreOrders) =>
      <Text
        size={12}
        className={'supplierStatus'}
        color={"#192c3d"}
      >
        {data.categoryDescription}
      </Text>
  },
  { label: "Itens", key: "totalItems", noFilter: true, size: 90, maxSize: 90 },
  {
    label: "Valor (R$)",
    key: "totalValueCD",
    noFilter: true,

    Component: (data: IPreOrders) => {
      return (
        <Text
          size={12}
          color={"#192c3d"}
        >
          {currencyOutputNumber(data.totalPrice)}
        </Text>
      );
    }
  },
  {
    label: "Baixar espelho",
    key: "",
    size: 60,
    noFilter: true,
    Component: (data: IPreOrders) => (
      <OrderMirrorButton
        viewed={data.viewed}
        quotationCode={data.code}
        sequenceNumbers={data.sequenceNumbers}
        distributionCenter={data.distributionCenter}
      />
    )
  }
];

export const downloadOrderModel: Array<ITableModel> = [
  { label: "Usuário", key: "name", size: 170, maxSize: 170, noFilter: true },
  {
    label: "Data",
    key: "updatedDate",
    type: "date/hour",
    noFilter: true,
    size: 125,
    maxSize: 125,
    Component: (data: ViewedOrderProps) => (
      <Text size={12}>
        {format(new Date(data.updatedDate), "dd/MM/yyyy")}
      </Text>
    ),
  },
  {
    label: "Horário",
    key: "updatedDate",
    type: "date/hour",
    noFilter: true,
    size: 30,
    Component: (data: ViewedOrderProps) => (
      <Text size={12}>
        {format(new Date(data.updatedDate), "HH:mm")}
      </Text>
    ),
  }
];